import { Suspense, lazy } from 'react'
import ScrollToTop from './helpers/scroll-top'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import useGlobalUserData from './hooks/useGlobalUserData'

// home pages
const HomeFashion = lazy(() => import('./pages/home/HomeFashion'))

// shop pages
const ShopGridStandard = lazy(() => import('./pages/shop/ShopGridStandard'))
const ShopSearch = lazy(() => import('./pages/shop/ShopSearch'))
const ShopFashion = lazy(() => import('./pages/shop/ShopFashion'))

// product pages
const ProductTabLeft = lazy(() => import('./pages/shop-product/ProductTabLeft'))


// qrcode pages
const QRCodePayment = lazy(() => import('./pages/other/qrcode'))


// other pages
const About = lazy(() => import('./pages/other/About'))
const ReturnRefundPolicy = lazy(() => import('./pages/other/ReturnRefundPolicy'))
const PrivacyPolicy = lazy(() => import('./pages/other/PrivacyPolicy'))
const TermsOfUse = lazy(() => import('./pages/other/TermsOfUse'))
const ShippingPolicy = lazy(() => import('./pages/other/ShippingPolicy'))
const Contact = lazy(() => import('./pages/other/Contact'))
const LoginRegister = lazy(() => import('./pages/other/LoginRegister'))
const Address = lazy(() => import('./pages/account/Address'))
const Orders = lazy(() => import('./pages/account/Orders'))
const Success = lazy(() => import('./pages/callback/success'))
const Failed = lazy(() => import('./pages/callback/failed'))
const Cart = lazy(() => import('./pages/other/Cart'))
const Wishlist = lazy(() => import('./pages/other/Wishlist'))
const Checkout = lazy(() => import('./pages/other/Checkout'))

const NotFound = lazy(() => import('./pages/other/NotFound'))

// 全局数据加载组件
function GlobalDataLoader() {
  useGlobalUserData();
  return null;
}

// 主应用路由组件
function AppRoutes() {
  return (
    <Routes>
      <Route path={process.env.PUBLIC_URL + '/'} element={<HomeFashion />} />

      {/* Shop pages */}
      <Route path={process.env.PUBLIC_URL + '/shop'} element={<ShopGridStandard />} />
      <Route path={process.env.PUBLIC_URL + '/shop/search'} element={<ShopSearch />} />
      <Route path={process.env.PUBLIC_URL + '/shop/fashion'} element={<ShopFashion />} />

      {/* Shop product pages */}
      <Route path={process.env.PUBLIC_URL + '/product/:id'} element={<ProductTabLeft />} />

      {/* QRCode pages */}
      <Route path={process.env.PUBLIC_URL + '/qrcode'} element={<QRCodePayment />} />


      {/* Account pages */}
      <Route path={process.env.PUBLIC_URL + '/account'} element={<Address />} />
      <Route path={process.env.PUBLIC_URL + '/account/Address'} element={<Address />} />
      <Route path={process.env.PUBLIC_URL + '/account/orders'} element={<Orders />} />
      <Route path={process.env.PUBLIC_URL + '/success'} element={<Success />} />
      <Route path={process.env.PUBLIC_URL + '/failed'} element={<Failed />} />
      {/* Other pages */}
      <Route path={process.env.PUBLIC_URL + '/about'} element={<About />} />
      <Route path={process.env.PUBLIC_URL + '/return-refund-policy'} element={<ReturnRefundPolicy />} />
      <Route path={process.env.PUBLIC_URL + '/privacy-policy'} element={<PrivacyPolicy />} />
      <Route path={process.env.PUBLIC_URL + '/terms-of-use'} element={<TermsOfUse />} />
      <Route path={process.env.PUBLIC_URL + '/shipping-policy'} element={<ShippingPolicy />} />
      <Route path={process.env.PUBLIC_URL + '/contact'} element={<Contact />} />
      <Route path={process.env.PUBLIC_URL + '/login'} element={<LoginRegister />} />

      <Route path={process.env.PUBLIC_URL + '/cart'} element={<Cart />} />
      <Route path={process.env.PUBLIC_URL + '/wishlist'} element={<Wishlist />} />
      <Route path={process.env.PUBLIC_URL + '/checkout'} element={<Checkout />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

// 主应用组件
function App() {
  return (
    <Router>
      <Suspense
        fallback={
          <div className="Arjikart-preloader-wrapper">
            <div className="Arjikart-preloader">
              <span></span>
              <span></span>
            </div>
          </div>
        }>
        <ScrollToTop>
          <GlobalDataLoader />
          <AppRoutes />
        </ScrollToTop>
      </Suspense>
    </Router>
  );
}

export default App;
